var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.question)?_c('div',[_c('sqr-input-number',{attrs:{"label":_vm.question.name,"value":_vm.answer,"min":_vm.question.min,"max":_vm.question.max,"required":_vm.question.required,"disabled":_vm.disabled,"v":_vm.v},on:{"change":_vm.change}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }